import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Question1 } from '../question1/question1';
import {UserData} from "../services/UserData";
import { AlertController } from 'ionic-angular';


@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  userData: UserData
  constructor(public navCtrl: NavController, private alertCtrl: AlertController) {
    this.userData = new UserData();
  }

  goToQuestion1() {
    this.navCtrl.push(Question1, this.userData);
  }

  // checkGradesValues () {
  //   // var mailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //   // mailRegex.test(this.userData.email)
  //   if (this.userData.firstName=='' || this.userData.lastName=='' || this.userData.roomNumber==''
  //       || this.userData.email=='')
  //   {
  //     /*let alert = this.alertCtrl.create({
  //       title: 'Error',
  //       subTitle: 'Please fill in all the fields!',
  //       buttons: ['OK']
  //     });
  //     alert.present();*/
  //     this.navCtrl.push(Question1, this.userData);
  //   }
  //   else {
  //     this.navCtrl.push(Question1, this.userData);
  //   }
  //}
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts